import React, {useEffect} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";
import ProjectUtils from "../../../../../utils/project-utils.js";
import {tableSortHeader} from "../../../../../components/reports/table-sort-header/table-sort-header.jsx";

const ReportContent = ({data, tableColumns}) => {

    const columns = [
        {id: "name", label: "Nome", className: "w-[10%]", sortField: "name", renderCell: element => element.name},
        {id: "cpf", label: "CPF", className: "w-[12%]", sortField: "cpf", renderCell: element => ProjectUtils.formatCpfToView(element.cpf) ?? ""},
        {id: "status", label: "Status", className: "w-[5%]", sortField: "status", renderCell: element => element.status ? "Ativo" : "Inativo"},
        {id: "sector", label: "Setor", className: "w-[7%]", sortField: "sector", renderCell: element => element.sector ?? ""},
        {id: "last_login", label: "Último acesso", className: "w-[10%]", sortField: "last_login", renderCell: element => ReportUtils.formatDateTimeLabel(element.last_login)},
        {id: "days_without_access", label: "Dias sem acesso", className: "w-[10%] text-center", sortField: "days_without_access", renderCell: element => element.days_without_access},
        {id: "search_passages", label: "Pesquisa de passagens", className: "w-[7%] text-center", sortField: "search_passages", renderCell: element => element.search_passages},
        {id: "export_images", label: "Exportação de imagens", className: "w-[7%] text-center", sortField: "export_images", renderCell: element => element.export_images},
        {id: "export_passages", label: "Relatório de Pesquisa de passagem", className: "w-[10%] text-center", sortField: "export_passages", renderCell: element => element.export_passages},
        {id: "correction_plates", label: "Correção de placas", className: "w-[7%] text-center", sortField: "correction_plates", renderCell: element => element.correction_plates},
        {id: "cortex_renavam", label: "Córtex - Pesquisa RENAVAM", className: "w-[10%] text-center", sortField: "cortex_renavam", renderCell: element => element.cortex_renavam},
        {id: "cortex_passages", label: "Córtex - Pesquisa Passagens", className: "w-[10%] text-center", sortField: "cortex_passages", renderCell: element => element.cortex_passages},
        {id: "total_my_occs", label: "Ocorrência somente do usuário", className: "w-[10%] text-center", sortField: "total_my_occs", renderCell: element => element.total_my_occs},
        {id: "monitoring_plates", label: "Ocorrência - monitoramento mobile", className: "w-[10%] text-center", sortField: "monitoring_plates", renderCell: element => element.monitoring_plates},
    ];
    const visibleColumns = columns.filter(column => tableColumns?.[column.id]?.visible !== false);

    useEffect(() => {
        ReportUtils.createExportableTable(null, null, `Auditoria uso do sistema`, "system-usage-data");
    }, [data, tableColumns]);

    const { order, handleSort, sortedData, getIcon } = tableSortHeader(data);

    return (
        <>
            {visibleColumns.length === 0 ? (
                <div className="alert alert-info p-2 h6 text-center mt-[20px]!">Todas as colunas foram ocultadas.</div>
            ) : <table id="system-usage-data" className="table report-table" sheet-name="Auditoria uso do sistema">
                <thead className="thead-background print:table-row-group!">
                    <tr className="bg-[#f6f6f6] text-left">
                        {visibleColumns.map(column => <th key={column.id} onClick={() => handleSort(column.sortField)} className={column.className} style={{cursor: 'pointer'}}>{tableColumns?.[column.id]?.label ?? column.label} {getIcon(order, column.sortField)}</th>)}
                    </tr>
                </thead>

                <tbody className="bg-white">
                    {sortedData.map((element, index) => <tr key={`visible-${index}`} className="table-break-word">{visibleColumns.map(column => <td key={column.id} className={column.className}>{column.renderCell(element)}</td>)}</tr>)}
                </tbody>
            </table>}

            <div id="chart-tables"/>

        </>
    );
};

export default ReportContent;